import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./BillingStatusForm";
import {cancelChangeBillingStatus} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "status");
  return errors.toJS();
}

const billingOptions = fromJS([
  {value: "delinquent", title: "Delinquent"},
  {value: "not_delinquent", title: "Not Delinquent"}
])

class ChangeBillingStatusFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    if (values.get("status") === "delinquent") {
      this.markAccountAsDelinquent();
    } else if (values.get("status") === "not_delinquent") {
      this.markAccountAsNotDelinquent();
    }
  }

  markAccountAsDelinquent() {
    return this.props.markAccountAsDelinquent({accountId: this.props.accountId})
      .then((response) => {
        if (response.data.markAccountAsDelinquent.errors.length <= 0) {
          this.props.cancelChangeBillingStatus();
        } else {
          let errors = createValidationErrors(response.data.markAccountAsDelinquent.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });          
  }

  markAccountAsNotDelinquent() {
    return this.props.markAccountAsNotDelinquent({accountId: this.props.accountId})
      .then((response) => {
        if (response.data.markAccountAsNotDelinquent.errors.length <= 0) {
          this.props.cancelChangeBillingStatus();
        } else {
          let errors = createValidationErrors(response.data.markAccountAsNotDelinquent.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });          
  }

  handleCancel() {
    this.props.cancelChangeBillingStatus();
  }

  render() {
    let initialValues = {
      status: "not_delinquent"
    }
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        options={billingOptions}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const MARK_ACCOUNT_DELINQUENT = gql`
  mutation markAccountAsDelinquent($accountId: ID!) {
    markAccountAsDelinquent(accountId: $accountId) {
      errors { key message }
    }
  }
`;

const MARK_ACCOUNT_NOT_DELINQUENT = gql`
  mutation markAccountAsNotDelinquent($accountId: ID!) {
    markAccountAsNotDelinquent(accountId: $accountId) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(MARK_ACCOUNT_DELINQUENT, {
    props: ({ mutate }) => ({
      markAccountAsDelinquent: (data) => mutate({
        variables: data 
      })
    })
  }),
  graphql(MARK_ACCOUNT_NOT_DELINQUENT, {
    props: ({ mutate }) => ({
      markAccountAsNotDelinquent: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelChangeBillingStatus})(withQueries(ChangeBillingStatusFormContainer));